import { experienceEvent } from '@/events/builders'
import type { EventTuple } from '@/events/types'
import type { PageEventHandler } from '@/play/pageTypes'
import { builtHill, hillIndex } from './world'

/**
 * Next hill: the world is replaced by authored hill number `hill` (hills.ts), in one event, so it is
 * one undo step (undo brings back the hill you just finished, everyone found) and replays from its
 * number alone (the hills are data; the cells are rebuilt from the definition). The camera, look
 * and the rest of the document stay.
 */
export const DIG_NEXT_HILL_EVENT = 'experience.dig-for-eyes.nextHill' as const

export function digNextHillEvent(hill: number): EventTuple {
  return experienceEvent(DIG_NEXT_HILL_EVENT, { hill: hillIndex(hill) })
}

/** Reducer handlers for Dig (`experience.dig-for-eyes.*`). */
export const eventHandlers: Record<string, PageEventHandler> = {
  [DIG_NEXT_HILL_EVENT]: (ctx, event) => {
    const hill = (event[1] as { hill?: unknown } | undefined)?.hill
    if (typeof hill !== 'number' || !Number.isFinite(hill)) return
    ctx.setBase(new Map(builtHill(hill).entries))
  },
}
